/**
 * Bildet einen Tipp plus sein Emoji-Feedback auf farbige Ziffern-Kacheln ab.
 *
 * Pastpuzzle vergleicht Jahreszahlen wie Wordle stellenweise, also gehört
 * jedes Emoji zu genau einer Ziffer. Statt Zahl und Emoji-Reihe
 * nebeneinander zu stellen, trägt hier jede Ziffer ihre eigene Farbe —
 * das ist auf einen Blick erfassbar.
 */

export type TileState = 'correct' | 'misplaced' | 'absent';

export interface DigitTile {
  digit: string;
  state: TileState;
}

/** Stellenzahl, auf die Pastpuzzle Jahre vergleicht. */
export const YEAR_DIGITS = 4;

const EMOJI_STATE: Record<string, TileState> = {
  '🟩': 'correct',
  '🟨': 'misplaced',
  '🟥': 'absent',
};

/** Für Screenreader — die Farbe allein darf die Information nicht tragen. */
export const TILE_LABEL: Record<TileState, string> = {
  correct: 'richtig',
  misplaced: 'falsche Stelle',
  absent: 'kommt nicht vor',
};

/**
 * Vierstellige Darstellung eines Jahres. Spiegelt bewusst `padDigits` aus
 * `backend/src/services/playEmojis.ts` — nur so passt Ziffer i zum Emoji i,
 * auch bei dreistelligen Jahren wie 477 ("0477").
 */
export function padYear(year: number): string {
  const abs = Math.abs(Math.trunc(year));
  return String(abs).padStart(YEAR_DIGITS, '0').slice(-YEAR_DIGITS);
}

export function toDigitTiles(guess: number, emojis: string): DigitTile[] {
  // Array.from statt split(''): die Emojis liegen außerhalb der BMP und
  // bestehen aus je zwei UTF-16-Einheiten.
  const states = Array.from(emojis);
  return Array.from(padYear(guess)).map((digit, index) => ({
    digit,
    // Fehlt ein Emoji (abgeschnittenes Pattern vom Server), lieber neutral
    // 'absent' anzeigen als die Kachel ohne Zustand zu rendern.
    state: EMOJI_STATE[states[index] ?? ''] ?? 'absent',
  }));
}
